// ClassCard.tsx
import React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

interface ClassCardProps {
  className?: string;
  professorName?: string;
  professorEmail?: string;
  classID: string;
}

const ClassCard: React.FC<ClassCardProps> = (props) => {
  const { className, professorName, professorEmail, classID } = props;
  return (
    <Card component="div" sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography variant="h5" component="div">
          {className}
        </Typography>
        <Typography variant="body2">Professor: {professorName}</Typography>
        <Typography variant="body2">Email: {professorEmail}</Typography>
        <Typography variant="body2">TA:TBD</Typography>
        <Typography variant="body2">No. Students: TBD</Typography>
      </CardContent>
      <CardActions>
        <Link to={`/admin/${classID}`} target="_blank">
          View Class Info
        </Link>
      </CardActions>
      <CardActions>
        <Link to={`/admin/enroll/${classID}`} target="_blank">
          Enroll Students
        </Link>
      </CardActions>
    </Card>
  );
};

export default ClassCard;
